module.exports = __webpack_public_path__ + "media/images/footer/en_rp-2d2ee149ac3079af50783d32f150392b.svg";